<!-- 发票抬头 -->
<template>
  <BaseFormItem2
    class="bill_id"
    label="抬头/税号"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <!-- 未登录 -->
    <NotLogin v-if="!isLogin" :isError="isError" text="请登录获取发票抬头信息" />
    <template v-else>
      <!-- 没数据 -->
      <BaseEmpty 
        v-if="options.length === 0"
        btnText="+新增一个" 
        :text="emptyText" 
        :isError="isError"
        @btnClick="handleAdd" 
      />
      <div v-else class="bill_id__content">
        <RadioTable2
          v-model="val"
          class="bill_id-table"
          radioKey="id"
          radioLabel="#"
          :height="200"
          :showExpand="true"
          :isError="isError"
          :loading="loading"
          :columns="columns"
          :tableData="options"
          @change="handleChange"
        >
          <template v-slot:isDefault="{ row }">
            <span v-if="row.isDefault == 1" class="bill_id-table__isDefault">
              默认
            </span>
          </template>
        </RadioTable2>

        <div class="bill_id__add">
          <BaseTextButton :plain="false" :light="true" @click="handleAdd">
            <i class="el-icon-circle-plus-outline" />
            新增
          </BaseTextButton>
        </div>
      </div>
    </template>

    <!-- 新增发票弹框 -->
    <EditInvoice 
      ref="editInvoiceRef" 
      :invoiceType="invoiceType" 
      @success="handleEditInvoice"
    />
  </BaseFormItem2>
</template>

<script>
// 未登录
import NotLogin from '@@/views/pcbQuote/components/notLogin'
// 单选表格
import RadioTable2 from '@@/components/radioTable/index2'
// 新增发票
import EditInvoice from '@@/components/invoice/editInvoice'

import { isLogin } from '@@/utils/is'
import { getInvoiceList } from '@@/api/customer'

export default {
  props: {
    // 发票id
    value: {
      type: [String, Number],
      default: ''
    },
    // 发票类型：1-增票 2-普票
    type: {
      type: Number,
      default: 2
    }
  },
  components: {
    NotLogin,
    RadioTable2,
    EditInvoice
  },
  data() {
    return {
      loading: false,
      val: this.value,
      invoiceType: this.type, // 1-增票 2-普票
      columns: [
        { label: '抬头', prop: 'invoiceTitle', showOverflowTooltip: true },
        { label: '税号', prop: 'taxCode' },
        { label: '', prop: 'isDefault', slot: 'isDefault', minWidth: 30 }
      ],
      options: [],
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    isLogin() {
      return isLogin()
    },
    emptyText() {
      return this.invoiceType == 1 ? '还没有 (专用) 发票抬头' : '还没有 (普通) 发票抬头'
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    type(type) {
      this.invoiceType = type
      this.getList()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.isShowError(false)
    },
    // 获取发票列表
    getList() {
      this.loading = true
      getInvoiceList({ invoiceType: this.invoiceType })
        .then(res => {
          if (!res) return
          const { suc, body } = res
          if (suc) {
            this.options = body ? body : []
            this.selectDefault()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 已选的 > 默认的 > 第一个
    selectDefault() {
      const { val, options } = this
      if (options && options.length > 0) {
        const item = options.find(i => (!!val ? i.id === val : i.isDef == 1)) || options[0]
        this.val = item.id
        this.handleChange(item)
      } else {
        this.val = ''
        this.handleChange()
      }
    },
    // 发票切换
    handleChange(item) {
      this.handleEmit()
      this.$emit('change', item ? {...item} : undefined)
    },
    // 打开新增发票弹框
    handleAdd() {
      this.$refs.editInvoiceRef.open()
    },
    // 新增发票成功
    handleEditInvoice(type, id) {
      this.invoiceType = type
      this.val = id
      this.getList()
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.bill_id {
  ::v-deep .base-form-item__content {
    width: calc(100% - 110px);
  }
  .bill_id-table {
    .bill_id-table__isDefault {
      display: inline-block;
      width: 36px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: $--color-warning;
      text-align: center;
      border-radius: 2px;
      background-color: #FDF6EC;
    }
  }
  .bill_id__content {
    position: relative;
    .bill_id__add {
      position: absolute;
      top: 0;
      right: -74px;
      &::before {
        content: '';
        position: absolute;
        left: -12px;
        top: 50%;
        display: block;
        width: 12px;
        height: 1px;
        background-color: #E1E1E1;
      }
    }
  }
}
</style>